import { Position } from '@/shared/ui/data/EditableGrid/types/core.type';
import { createPosition, isSamePosition } from '@/shared/ui/data/EditableGrid/lib/position';

export type SelectionMode = 'single' | 'drag' | 'range' | 'multi';

export interface SelectionRange {
  readonly start: Position;
  readonly end: Position;
}

export function selectSingleCell(position: Position): ReadonlyArray<Position> {
  return [position];
}

export function selectRange(range: SelectionRange): ReadonlyArray<Position> {
  const { start, end } = range;

  const minRow = Math.min(start.rowIndex, end.rowIndex);
  const maxRow = Math.max(start.rowIndex, end.rowIndex);
  const minCol = Math.min(start.colIndex, end.colIndex);
  const maxCol = Math.max(start.colIndex, end.colIndex);

  const positions: Position[] = [];

  for (let row = minRow; row <= maxRow; row++)
    for (let col = minCol; col <= maxCol; col++) positions.push(createPosition(row, col));

  return positions;
}

export function addToSelection(
  currentSelection: ReadonlyArray<Position>,
  newPosition: Position
): ReadonlyArray<Position> {
  const alreadySelected = currentSelection.some((pos) => isSamePosition(pos, newPosition));

  if (alreadySelected) return currentSelection.filter((pos) => !isSamePosition(pos, newPosition));
  else return [...currentSelection, newPosition];
}

export function clearSection(): ReadonlyArray<Position> {
  return [];
}
